import type { HeapTagsT } from '../analytics/types/performance';

// performance.memory is deprecated/Chrome-only. The async replacement requires cross-origin
// isolation (COOP/COEP) that labeling-web doesn't support. Keep with availability guard.
interface PerformanceMemory {
  usedJSHeapSize: number;
  totalJSHeapSize: number;
  jsHeapSizeLimit: number;
}
function getPerformanceMemory(): PerformanceMemory | undefined {
  if (typeof window === 'undefined' || !window.performance) return undefined;
  return ((window.performance as unknown) as {
    memory?: PerformanceMemory;
  }).memory;
}

/** Returns heap tags read fresh at each call. */
export function getHeapTags(): HeapTagsT {
  const memory = getPerformanceMemory();
  return {
    browserHeapUsed: memory ? Math.round(memory.usedJSHeapSize / (1024 * 1024)) : 0,
    browserHeapTotal: memory ? Math.round(memory.totalJSHeapSize / (1024 * 1024)) : 0
  };
}